import { ensureSignedIn, providerIsSignedIn } from "../auth/microsoftAuth";
import { MS365Document } from "../types/types";
import { normalizeTimelineData } from "./GraphTimelineNormalizer";

export const fetchCopilotData = async (
  search?: string,
  maxResults: number = 10
): Promise<MS365Document[]> => {
  try {
    const provider = await ensureSignedIn();
    if (!provider || !providerIsSignedIn(provider.state)) return [];

    const graphClient = provider.graph.client;

    const body = {
      queryString: search ?? "",
      dataSource: "oneDriveBusiness",
      resourceMetadata: ["Title", "Author", "FileExtension", "Filename", "FileType", "InformationProtectionLabelId", "LastModifiedTime", "ModifiedBy", "Path", "SiteID"],
      maximumNumberOfResults: maxResults,
    };

    const res = await graphClient
      .api("/copilot/retrieval")
      .version("beta")
      .post(body)
      .catch(() => null);

      // Query OneDrive Business
      const oneDriveResults = res ?? [];

      // Query SharePoint
      const sharepointBody = {
        ...body,
        dataSource: "sharePoint",
      };

      const sharepointRes = await graphClient
        .api("/copilot/retrieval")
        .version("beta")
        .post(sharepointBody)
        .catch(() => null);

      const sharepointResults = sharepointRes ?? [];

      // Combine results
      const combinedHits = [
        ...(oneDriveResults.retrievalHits ?? []),
        ...(sharepointResults.retrievalHits ?? [])
      ];

    if (!res) return [];

    // The beta API shape can vary; try common containers
    const resultData =
      (res && (res.value || res.results || res.data)) ?? res ?? [];

    return null; //normalizeTimelineData([], [], [], [], resultData.retrievalHits as any[]);
  } catch (error) {
    console.error("Error fetching Copilot data:", error);
    return [];
  }
};
